import { StateProvider } from '@uirouter/angularjs'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'
import { Activity } from '../../models/common/'
import { OpOperator } from '../../models/core/'
import { IUserSession, UserSession, ConfigHelper } from '../../helpers/'
import { ScriptsController } from './scripts.controller'
import { $SCOPE_SERVICE_NAME, $STATE_SERVICE_PROVIDER_NAME, $TIMEOUT_SERVICE_NAME } from '../../services/system'
import { USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'

import './scripts.scss'
import * as TEMPLATE from './scripts.tpl.html'


// Consts

const CONTROLLER_NAME: string = 'ScriptsController'
const MENU_INDEX = 17
const MODULE_NAME: string = 'simax.scripts'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'Scripts'
const STATE_NAME: string = 'scripts'
const STATE_URL: string = '/scripts'
const TEMPLATE_PATH: string = './scripts.tpl.html'

// Consts End

// Setup

const module = angular.module(MODULE_NAME, [])

module.controller(CONTROLLER_NAME, [$SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, USER_SESSION_SERVICE_NAME, (
    $scope,
    $timeout,
    userSession: IUserSession
) => new ScriptsController(
    $scope,
    $timeout,
    userSession
)])

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, ($stateProvider: StateProvider, userSessionProvider: UserSession) => {
    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.WEBSIMAX_CUSTOM_SCRIPT_RUN_OP)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.SCRIPTS),
                    'scripts',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                })
            }
        })
}])

// Setup End

export default MODULE_NAME